<template>
  <v-navigation-drawer
    v-model="formShow"
    clipped
    right
    fixed
    width="30rem"
    style="top: 100px"
    stateless
  >
    <v-form
      ref="form"
      lazy-validation
      class="d-flex flex-column"
      style="height: calc(100% - 100px)"
    >
      <v-toolbar flat dark color="primary">
        <v-list-item class="px-0" two-line>
          <v-list-item-content>
            <v-list-item-title>
              {{ lockUnlockInit.hardware.title_th }}
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ lockUnlockInit.hardware.hardware_code }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-spacer></v-spacer>

        <v-btn icon @click="onClose">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <div style="height: 100%; overflow: auto">
        <v-tabs
          v-model="tabLockUnlock"
          style="border-bottom: 1px solid #eeeeee"
        >
          <v-tab :disabled="uiCtrl && !uiCtrl.isEnable('tab:::lock:get')"
            >Lock</v-tab
          >
          <v-tab :disabled="uiCtrl && !uiCtrl.isEnable('tab:::unlock:get')"
            >Unlock</v-tab
          >
        </v-tabs>
        <v-tabs-items v-model="tabLockUnlock" class="pa-5">
          <v-tab-item>
            <div>
              <v-btn
                :disabled="uiCtrl && !uiCtrl.isEnable('btn:::lock:update')"
                @click="handleCopyFrom"
                outlined
                color="primary"
                class="mr-4"
              >
                <v-icon left color="#212121">mdi-tray-arrow-down</v-icon>
                คัดลอกจากเครื่องอื่น
              </v-btn>
              <v-btn
                @click="handleCopyTo"
                :disabled="
                  isLockUnlockDataChange ||
                  (uiCtrl && !uiCtrl.isEnable('btn:::lock:update'))
                "
                outlined
                color="primary"
              >
                <v-icon left color="#212121">mdi-tray-arrow-up</v-icon>
                คัดลอกไปที่...
              </v-btn>
            </div>
            <div class="mt-5">
              <tabs @selectedTab="handleSelectedTab" fullWidth>
                <tab
                  v-for="lockDetail in lockUnlock.lock_detail"
                  :key="lockDetail.day_type.day_type_id"
                  :title="lockDetail.day_type.title_short_th"
                >
                  <div class="d-flex align-center justify-space-between pb-3">
                    <div class="d-flex align-center">
                      <label class="mr-2">คัดลอกข้อมูล</label>
                      <div style="width: 120px">
                        <v-select
                          :disabled="
                            uiCtrl && !uiCtrl.isEnable('btn:::lock:update')
                          "
                          v-model="selectDayCopy"
                          style="background-color: white"
                          :items="[
                            { text: '-', value: 0 },
                            { text: 'อาทิตย์', value: 1 },
                            { text: 'จันทร์', value: 2 },
                            { text: 'อังคาร', value: 3 },
                            { text: 'พุธ', value: 4 },
                            { text: 'พฤหัสบดี', value: 5 },
                            { text: 'ศุกร์', value: 6 },
                            { text: 'เสาร์', value: 7 },
                          ]"
                          item-text="text"
                          item-value="value"
                          :item-disabled="
                            (item) =>
                              item.value === lockDetail.day_type.day_type_id ||
                              item.value === 0
                          "
                          hide-details
                          outlined
                          dense
                          @change="
                            handleChangeDayCopy(lockDetail.day_type.day_type_id)
                          "
                        ></v-select>
                      </div>
                    </div>
                    <div>
                      <v-btn
                        depressed
                        color="primary"
                        class="mr-2"
                        :disabled="
                          selectDayCopy === 0 ||
                          (uiCtrl && !uiCtrl.isEnable('btn:::lock:update'))
                        "
                        @click="handleCopyDay"
                      >
                        คัดลอก
                      </v-btn>
                      <v-btn
                        depressed
                        color="error"
                        :disabled="
                          selectDayCopy === 0 ||
                          (uiCtrl && !uiCtrl.isEnable('btn:::lock:update'))
                        "
                        @click="handleCopyDayCancel"
                      >
                        ยกเลิก
                      </v-btn>
                    </div>
                  </div>
                  <v-divider></v-divider>
                  <div class="mt-3">
                    <div
                      class="d-flex align-center mb-2"
                      v-for="lockTimePeriod in lockDetail.lock_time_period"
                      :key="lockTimePeriod.display_order"
                    >
                      <label class="flex-shrink-0 mr-3">
                        ช่วงเวลาที่ {{ lockTimePeriod.display_order }}
                      </label>
                      <TimePicker
                        v-model="lockTimePeriod.time_period_start"
                        :className="
                          lockUnlockCurrent
                            ? 'red-text-input centered-input'
                            : 'centered-input'
                        "
                        :disabled="
                          lockUnlockCurrent
                            ? true
                            : false ||
                              (uiCtrl && !uiCtrl.isEnable('btn:::lock:update'))
                        "
                        :rules="[
                          !lockTimePeriod.time_period_start &&
                          lockTimePeriod.time_period_end
                            ? false
                            : true,
                        ]"
                      />
                      <span class="mx-2">-</span>
                      <TimePicker
                        v-model="lockTimePeriod.time_period_end"
                        :className="
                          lockUnlockCurrent
                            ? 'red-text-input centered-input'
                            : 'centered-input'
                        "
                        :disabled="
                          lockUnlockCurrent
                            ? true
                            : false ||
                              (uiCtrl && !uiCtrl.isEnable('btn:::lock:update'))
                        "
                        :rules="[
                          lockTimePeriod.time_period_start &&
                          !lockTimePeriod.time_period_end
                            ? false
                            : true,
                        ]"
                      />
                    </div>
                  </div>
                </tab>
              </tabs>
            </div>
          </v-tab-item>
          <v-tab-item>
            <div>
              <v-btn
                :disabled="uiCtrl && !uiCtrl.isEnable('btn:::unlock:update')"
                @click="handleCopyFrom"
                outlined
                color="primary"
                class="mr-4"
              >
                <v-icon left color="#212121">mdi-tray-arrow-down</v-icon>
                คัดลอกจากเครื่องอื่น
              </v-btn>
              <v-btn
                @click="handleCopyTo"
                :disabled="
                  isLockUnlockDataChange ||
                  (uiCtrl && !uiCtrl.isEnable('btn:::unlock:update'))
                "
                outlined
                color="primary"
              >
                <v-icon left color="#212121">mdi-tray-arrow-up</v-icon>
                คัดลอกไปที่...
              </v-btn>
            </div>
            <div class="mt-5">
              <tabs @selectedTab="handleSelectedTab" fullWidth>
                <tab
                  v-for="unlockDetail in lockUnlock.unlock_detail"
                  :key="unlockDetail.day_type.day_type_id"
                  :title="unlockDetail.day_type.title_short_th"
                >
                  <div class="d-flex align-center justify-space-between pb-3">
                    <div class="d-flex align-center">
                      <label class="mr-2">คัดลอกข้อมูล</label>
                      <div style="width: 120px">
                        <v-select
                          :disabled="
                            uiCtrl && !uiCtrl.isEnable('btn:::unlock:update')
                          "
                          v-model="selectDayCopy"
                          style="background-color: white"
                          :items="[
                            { text: '-', value: 0 },
                            { text: 'อาทิตย์', value: 1 },
                            { text: 'จันทร์', value: 2 },
                            { text: 'อังคาร', value: 3 },
                            { text: 'พุธ', value: 4 },
                            { text: 'พฤหัสบดี', value: 5 },
                            { text: 'ศุกร์', value: 6 },
                            { text: 'เสาร์', value: 7 },
                          ]"
                          item-text="text"
                          item-value="value"
                          :item-disabled="
                            (item) =>
                              item.value ===
                                unlockDetail.day_type.day_type_id ||
                              item.value === 0
                          "
                          hide-details
                          outlined
                          dense
                          @change="
                            handleChangeDayCopy(
                              unlockDetail.day_type.day_type_id
                            )
                          "
                        ></v-select>
                      </div>
                    </div>
                    <div>
                      <v-btn
                        depressed
                        color="primary"
                        class="mr-2"
                        :disabled="
                          selectDayCopy === 0 ||
                          (uiCtrl && !uiCtrl.isEnable('btn:::unlock:update'))
                        "
                        @click="handleCopyDay"
                      >
                        คัดลอก
                      </v-btn>
                      <v-btn
                        depressed
                        color="error"
                        :disabled="
                          selectDayCopy === 0 ||
                          (uiCtrl && !uiCtrl.isEnable('btn:::unlock:update'))
                        "
                        @click="handleCopyDayCancel"
                      >
                        ยกเลิก
                      </v-btn>
                    </div>
                  </div>
                  <v-divider></v-divider>
                  <div class="mt-3">
                    <div
                      class="d-flex align-center mb-2"
                      v-for="unlockTimePeriod in unlockDetail.unlock_time_period"
                      :key="unlockTimePeriod.display_order"
                    >
                      <label class="flex-shrink-0 mr-3">
                        ช่วงเวลาที่ {{ unlockTimePeriod.display_order }}
                      </label>
                      <TimePicker
                        v-model="unlockTimePeriod.time_period_start"
                        :className="
                          lockUnlockCurrent
                            ? 'red-text-input centered-input'
                            : 'centered-input'
                        "
                        :disabled="
                          lockUnlockCurrent
                            ? true
                            : false ||
                              (uiCtrl &&
                                !uiCtrl.isEnable('btn:::unlock:update'))
                        "
                        :rules="[
                          !unlockTimePeriod.time_period_start &&
                          unlockTimePeriod.time_period_end
                            ? false
                            : true,
                        ]"
                      />
                      <span class="mx-2">-</span>
                      <TimePicker
                        v-model="unlockTimePeriod.time_period_end"
                        :className="
                          lockUnlockCurrent
                            ? 'red-text-input centered-input'
                            : 'centered-input'
                        "
                        :disabled="
                          lockUnlockCurrent
                            ? true
                            : false ||
                              (uiCtrl &&
                                !uiCtrl.isEnable('btn:::unlock:update'))
                        "
                        :rules="[
                          unlockTimePeriod.time_period_start &&
                          !unlockTimePeriod.time_period_end
                            ? false
                            : true,
                        ]"
                      />
                    </div>
                  </div>
                </tab>
              </tabs>
            </div>
          </v-tab-item>
        </v-tabs-items>
      </div>
      <v-toolbar flat color="blue-grey lighten-4">
        <v-row justify="center" align="center">
          <v-btn
            :disabled="
              !isLockUnlockDataChange ||
              (tabLockUnlock === 0 &&
                uiCtrl &&
                !uiCtrl.isEnable('btn:::lock:update')) ||
              (tabLockUnlock === 1 &&
                uiCtrl &&
                !uiCtrl.isEnable('btn:::unlock:update'))
            "
            class="primary mr-3"
            depressed
            @click="onSave"
            >บันทึก
          </v-btn>
          <v-btn depressed @click="onReset">ยกเลิก</v-btn>
        </v-row>
      </v-toolbar>
    </v-form>
    <v-dialog v-model="dialogCopyFrom" persistent width="720">
      <v-card>
        <v-card-title class="grey lighten-2 d-flex">
          <div class="flex-grow-1">
            <v-icon left x-large>mdi-tray-arrow-down</v-icon>
            คัดลอกจากเครื่องอื่น
            {{ tabLockUnlock === 0 ? '(LOCK)' : '(UNLOCK)' }}
          </div>
          <div>
            <v-btn icon @click="handleCancelCopyFrom">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
        </v-card-title>

        <v-card-text class="py-6">
          <v-row>
            <v-col class="py-0" cols="12" lg="6">
              <label class="caption"> ค้นหา </label>
              <v-text-field
                v-model="searchTableCopyFrom"
                class="fix-google-chrome"
                prepend-inner-icon="mdi-magnify"
                outlined
                dense
                clearable
                hide-details
              >
              </v-text-field
            ></v-col>
            <v-col class="py-0" cols="12" lg="6">
              <label class="caption"> รุ่นของ Device </label>
              <v-autocomplete
                v-model="filterHardwareModelCopyFrom"
                class="fix-google-chrome"
                :items="hardwareModels"
                item-text="title"
                item-value="hardware_model_code"
                hide-details
                outlined
                dense
                clearable
              >
              </v-autocomplete
            ></v-col>
          </v-row>
          <div class="mt-5" style="height: 300px; overflow-y: auto">
            <v-data-table
              v-model="selectedCopyFrom"
              :headers="headersTableCopyFrom"
              :items="tabLockUnlock === 0 ? locks : unlocks"
              single-select
              :item-key="tabLockUnlock === 0 ? 'lock_uuid' : 'unlock_uuid'"
              show-select
              :search="searchTableCopyFrom"
              :custom-filter="filterTableCopyFrom"
              class="elevation-1 ma-1"
              hide-default-footer
            >
              <template v-slot:item.hardware.title_th="{ item }">
                <v-list-item class="px-0" two-line>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ item.hardware.title_th }}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      {{ item.hardware.hardware_code }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </template>
              <template v-slot:item.view="{ item }">
                <button
                  type="button"
                  class="btn-text"
                  @click.stop="handleClickView(item)"
                >
                  ดูแผนภาพ
                </button>
              </template>
            </v-data-table>
          </div>
          <div class="mt-5">
            <v-btn
              @click="dialogConfirmCopyFrom = true"
              :disabled="!selectedCopyFrom.length"
              color="primary"
              class="mr-2"
              >คัดลอก</v-btn
            >
            <v-btn @click="handleCancelCopyFrom">ยกเลิก</v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogCopyTo" persistent width="720">
      <v-card>
        <v-card-title class="grey lighten-2 d-flex">
          <div class="flex-grow-1">
            <v-icon left x-large>mdi-tray-arrow-up</v-icon>
            คัดลอกไปที่... {{ tabLockUnlock === 0 ? '(LOCK)' : '(UNLOCK)' }}
          </div>
          <div>
            <v-btn icon @click="handleCancelCopyTo">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
        </v-card-title>

        <v-card-text class="py-6">
          <v-row>
            <v-col class="py-0" cols="12" lg="4">
              <label class="caption"> ค้นหา </label>
              <v-text-field
                v-model="searchTableCopyTo"
                class="fix-google-chrome"
                prepend-inner-icon="mdi-magnify"
                outlined
                dense
                clearable
                hide-details
              >
              </v-text-field
            ></v-col>
            <v-col class="py-0" cols="12" lg="4">
              <label class="caption"> รุ่นของ Device </label>
              <v-autocomplete
                v-model="filterHardwareModelCopyTo"
                class="fix-google-chrome"
                :items="hardwareModels"
                item-text="title"
                item-value="hardware_model_code"
                hide-details
                outlined
                dense
                clearable
              >
              </v-autocomplete
            ></v-col>
            <v-col class="py-0" cols="12" lg="4">
              <label class="caption"> กลุ่ม Device </label>
              <v-autocomplete
                v-model="filterHardwareGroups"
                class="fix-google-chrome"
                :loading="loadingHardwareGroups"
                :disabled="loadingHardwareGroups"
                :items="hardwaresGroup"
                outlined
                dense
                chips
                item-text="title_th"
                item-value="hardware_group_uuid"
                multiple
              >
                <template v-slot:selection="{ index, item }">
                  <v-chip
                    v-if="filterHardwareGroups.length > 1 && index === 0"
                    label
                  >
                    เลือกทั้งหมด {{ filterHardwareGroups.length }} กลุ่ม
                  </v-chip>
                  <v-chip v-if="filterHardwareGroups.length === 1" label>
                    {{ item.title_th }}
                  </v-chip>
                </template>
                <template v-slot:item="{ item, on, attrs }">
                  <v-list-item
                    v-bind="attrs"
                    v-on="on"
                    @change="
                      handleSelectedHardwareGroup(
                        attrs.inputValue,
                        item.hardware_group_uuid
                      )
                    "
                  >
                    <template v-slot:default="{ active }">
                      <v-list-item-action>
                        <v-checkbox :input-value="active"></v-checkbox>
                      </v-list-item-action>

                      <v-list-item-content>
                        <v-list-item-title>
                          <div class="d-flex justify-space-between">
                            <span class="mr-4">{{ item.title_th }}</span>
                            <!-- <span>{{ item.total_hardware }}</span> -->
                          </div>
                        </v-list-item-title>
                      </v-list-item-content>
                    </template>
                  </v-list-item>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
          <div class="mt-5" style="height: 300px; overflow-y: auto">
            <v-data-table
              v-model="selectedCopyTo"
              :headers="headersTableCopyTo"
              :items="tabLockUnlock === 0 ? locks : unlocks"
              :item-key="tabLockUnlock === 0 ? 'lock_uuid' : 'unlock_uuid'"
              show-select
              :search="searchTableCopyTo"
              :custom-filter="filterTableCopyTo"
              class="elevation-1 ma-1"
              hide-default-footer
            >
              <template v-slot:item.hardware.title_th="{ item }">
                <v-list-item class="px-0" two-line>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ item.hardware.title_th }}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      {{ item.hardware.hardware_code }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-data-table>
          </div>
          <div class="mt-5">เลือก {{ selectedCopyTo.length }} Device</div>
          <div class="mt-5">
            <v-btn
              @click="dialogConfirmCopyTo = true"
              :disabled="!selectedCopyTo.length"
              color="primary"
              class="mr-2"
              >คัดลอก</v-btn
            >
            <v-btn @click="handleCancelCopyTo">ยกเลิก</v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogView" width="1280">
      <v-card>
        <v-card-title class="body-2 grey lighten-2 d-flex">
          <div class="flex-grow-1 d-flex">
            <div style="width: 280px">
              <div style="color: gray">รหัส Device :</div>
              <div class="body-2">
                {{ hardwareLockUnlockTableView.hardware_code }}
              </div>
            </div>
            <div>
              <div style="color: gray">คำอธิบาย Device</div>
              <div class="body-2">
                {{ hardwareLockUnlockTableView.title_th }}
              </div>
            </div>
          </div>
          <div>
            <v-btn icon @click="dialogView = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
        </v-card-title>

        <v-card-text class="py-6">
          <v-tabs
            v-model="tabLockUnlockTableView"
            centered
            style="border-bottom: 1px solid #eeeeee"
          >
            <v-tab>{{ tabLockUnlock === 0 ? 'Lock' : 'Unlock' }}</v-tab>
          </v-tabs>
          <v-tabs-items v-model="tabLockUnlockTableView">
            <v-tab-item>
              <TimeTableView
                :timeTableData="hardwareLockUnlockTableView.time_detail"
              />
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogConfirmCopyFrom" persistent max-width="420">
      <v-card>
        <v-card-title>
          ยืนยันคัดลอกข้อมูล {{ tabLockUnlock === 0 ? 'LOCK' : 'UNLOCK' }}
        </v-card-title>
        <v-card-text> ข้อมูลของท่านจะถูกแทนที่ด้วยข้อมูลใหม่ </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary darken-1"
            text
            @click="handleConfirmSubmitCopyFrom"
          >
            ตกลง
          </v-btn>
          <v-btn text @click="dialogConfirmCopyFrom = false"> ยกเลิก </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogConfirmCopyTo" persistent max-width="420">
      <v-card>
        <v-card-title>
          ยืนยันคัดลอกข้อมูล
          {{ tabLockUnlock === 0 ? 'LOCK' : 'UNLOCK' }} ไปที่...
        </v-card-title>
        <v-card-text>
          ข้อมูลของท่านจะถูกคัดลอกไปที่ Device ที่เลือก
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary darken-1"
            text
            @click="handleConfirmSubmitCopyTo"
          >
            ตกลง
          </v-btn>
          <v-btn text @click="dialogConfirmCopyTo = false"> ยกเลิก </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogProgressCopyTo" persistent max-width="420">
      <v-card class="pa-5">
        <v-progress-linear v-model="progressCopyToValue" height="25">
          <strong
            >{{ progressCopyToSuccess }} / {{ selectedCopyTo.length }}</strong
          >
        </v-progress-linear>
      </v-card>
    </v-dialog>
    <ConfirmDialog
      :dialog="confirmDialogDataChange"
      :loading="confirmDialogDataChangeLoading"
      :dialogData="confirmDialogDataChangeData"
      @cancelConfirmDialog="cancelConfirmDialogDataChange"
      @submitConfirmDialog="submitConfirmDialogDataChange"
    />
    <ForbiddenDialog
      :dialog="dialogForbidden"
      @onCloseDialog="dialogForbidden = false"
    />
    <v-dialog v-model="dialogAlertSelectDayCopy" width="500">
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          ยืนยันคัดลอกข้อมูล
        </v-card-title>

        <v-card-text class="mt-5">
          กรุณายืนยันการคัดลอกข้อมูล หรือยกเลิก
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialogAlertSelectDayCopy = false">
            ปิด
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-navigation-drawer>
</template>

<script>
import _ from 'lodash'
import { mapActions } from 'vuex'

// @ is an alias to /src
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import Tab from '@/components/Tab.vue'
import Tabs from '@/components/Tabs.vue'
import TimePicker from '@/components/TimePicker.vue'
import TimeTableView from '@/components/TimeTableView.vue'

export default {
  components: {
    ConfirmDialog,
    Tab,
    Tabs,
    TimePicker,
    TimeTableView,
  },
  props: {
    formShow: {
      type: Boolean,
      default: false,
    },
    lockUnlock: {
      type: Object,
    },
    lockUnlockInit: {
      type: Object,
    },
  },
  data() {
    return {
      dialogAlertSelectDayCopy: false,
      dialogForbidden: false,
      loadingHardwareModels: false,
      loadingHardwareGroups: false,
      filterHardwareGroups: [],
      progressCopyToSuccess: 0,
      progressCopyToValue: 0,
      tabLockUnlockTableView: 'tabLockUnlockTableView',
      hardwareLockUnlockTableView: {
        hardware_code: '',
        title_th: '',
        time_detail: [],
      },
      searchTableCopyFrom: '',
      searchTableCopyTo: '',
      filterHardwareModelCopyFrom: '',
      filterHardwareModelCopyTo: '',
      selectedCopyFrom: [],
      selectedCopyTo: [],
      dialogCopyFrom: false,
      dialogCopyTo: false,
      tabLockUnlock: 'tabLockUnlock',
      lockUnlockCurrent: null,
      selectDayCopy: 0,
      confirmDialogDataChange: false,
      confirmDialogDataChangeLoading: false,
      confirmDialogDataChangeData: {},
      dialogView: false,
      dialogConfirmCopyFrom: false,
      dialogConfirmCopyTo: false,
      dialogProgressCopyTo: false,
      timeout: null,
      locks: [],
      unlocks: [],
    }
  },
  computed: {
    uiCtrl() {
      return this.$store.state.uiCtrl
    },
    headersTableCopyFrom() {
      return [
        {
          text: 'Device',
          align: 'start',
          value: 'hardware.title_th',
        },
        {
          text: 'ชื่อรุ่น Device',
          value: 'hardware.hardware_model_code',
          filter: (value) => {
            if (!this.filterHardwareModelCopyFrom) return true

            return value === this.filterHardwareModelCopyFrom
          },
        },
        { text: 'ดูแผนภาพ', value: 'view' },
      ]
    },
    headersTableCopyTo() {
      return [
        {
          text: 'Device',
          align: 'start',
          value: 'hardware.title_th',
        },
        {
          text: 'ชื่อรุ่น Device',
          value: 'hardware.hardware_model_code',
          filter: (value) => {
            if (!this.filterHardwareModelCopyTo) return true

            return value === this.filterHardwareModelCopyTo
          },
        },
      ]
    },
    isLockUnlockDataChange() {
      if (
        JSON.stringify(this.lockUnlock) !== JSON.stringify(this.lockUnlockInit)
      ) {
        this.$emit('isLockUnlockDataChange', true)
        return true
      }
      this.$emit('isLockUnlockDataChange', false)
      return false
    },
    hardwareModels() {
      return this.$store.state.hardware.hardwareModels
    },
    hardwaresGroup() {
      return this.$store.state.hardwaresGroup.hardwaresGroup
    },
  },
  methods: {
    ...mapActions({
      fetchHardwaresGroupMember: 'hardwaresGroup/fetchHardwaresGroupMember',
      fetchHardwaresGroup: 'hardwaresGroup/fetchHardwaresGroup',
      fetchHardwareModels: 'hardware/fetchHardwareModels',
      fetchLocks: 'lockUnlock/fetchLocks',
      fetchUnlocks: 'lockUnlock/fetchUnlocks',
      editLock: 'lockUnlock/editLock',
      editUnlock: 'lockUnlock/editUnlock',
    }),
    handleSelectedHardwareGroup(event, uuid) {
      this.$store.state.loading = true

      const { company_uuid } = this.$store.state.authentication.company

      this.fetchHardwaresGroupMember({
        company_uuid,
        hardware_group_uuid: uuid,
      })
        .then(({ total, data }) => {
          if (total === 0) return
          const tabKey = this.tabLockUnlock === 0 ? 'locks' : 'unlocks'
          if (!event) {
            const allData = this.$store.state.lockUnlock[tabKey]
            const results = allData
              .filter((item) =>
                data.some(
                  (s) => s.hardware_uuid === item.hardware.hardware_uuid
                )
              )
              .map((result) => ({
                ...result,
                hardware_group_uuid: uuid,
              }))
            if (this.filterHardwareGroups.length === 1) {
              this[tabKey] = [...results]
            }
            if (this.filterHardwareGroups.length > 1) {
              const data = results.map((result) => ({
                ...result,
                hardware_group_uuid: uuid,
              }))
              this[tabKey] = _.uniqBy(
                [...this[tabKey], ...data],
                this.tabLockUnlock === 0 ? 'lock_uuid' : 'unlock_uuid'
              )
            }
          }
          if (event) {
            if (this.filterHardwareGroups.length === 0) {
              this[tabKey] = this.$store.state.lockUnlock[tabKey]
            }
            if (this.filterHardwareGroups.length > 0) {
              this[tabKey] = this[tabKey].filter(
                (item) =>
                  !(
                    data.some(
                      (s) => s.hardware_uuid === item.hardware.hardware_uuid
                    ) && item.hardware_group_uuid === uuid
                  )
              )
            }
          }
        })
        .catch((error) => {
          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        })
        .finally(() => {
          this.$store.state.loading = false
        })
    },
    handleConfirmSubmitCopyFrom() {
      this.dialogConfirmCopyFrom = false
      if (this.tabLockUnlock === 0) {
        this.$emit('onCopyFrom', {
          ...this.lockUnlock,
          lock_detail: [...this.selectedCopyFrom[0].lock_detail],
        })
      }
      if (this.tabLockUnlock === 1) {
        this.$emit('onCopyFrom', {
          ...this.lockUnlock,
          unlock_detail: [...this.selectedCopyFrom[0].unlock_detail],
        })
      }
      this.dialogCopyFrom = false
      this.selectedCopyFrom = []
    },
    async handleConfirmSubmitCopyTo() {
      this.dialogConfirmCopyTo = false
      this.dialogProgressCopyTo = true

      const { company_uuid } = this.$store.state.authentication.company

      if (this.tabLockUnlock === 0) {
        for (const lock of this.selectedCopyTo) {
          const payloadLock = {
            company_uuid,
            hardware_uuid: lock.hardware?.hardware_uuid,
            body: {
              title_th: 'title_th',
              title_en: 'title_en',
              lock_detail: this.lockUnlock.lock_detail.map((item) => ({
                day_type_id: item.day_type.day_type_id,
                lock_time_period: item.lock_time_period,
              })),
            },
            params: {
              dpc: 'lock-unlock-to-update-lock',
            },
          }

          try {
            await this.editLock(payloadLock)

            this.progressCopyToSuccess += 1
            this.progressCopyToValue =
              (100 / this.selectedCopyTo.length) * this.progressCopyToSuccess
          } catch (error) {
            if (error.response && error.response.status === 403) {
              this.dialogForbidden = true
              return
            }

            const snackbar = {
              show: true,
              color: 'error',
              timeout: -1,
              message:
                error?.response?.data?.message || 'Something went wrong!',
            }
            this.$store.commit('SET_SNACKBAR', snackbar)
          }
        }
      }
      if (this.tabLockUnlock === 1) {
        for (const unlock of this.selectedCopyTo) {
          const payloadUnlock = {
            company_uuid,
            hardware_uuid: unlock.hardware?.hardware_uuid,
            body: {
              title_th: 'title_th',
              title_en: 'title_en',
              unlock_detail: this.lockUnlock.unlock_detail.map((item) => ({
                day_type_id: item.day_type.day_type_id,
                unlock_time_period: item.unlock_time_period,
              })),
            },
            params: {
              dpc: 'lock-unlock-to-update-unlock',
            },
          }

          try {
            await this.editUnlock(payloadUnlock)

            this.progressCopyToSuccess += 1
            this.progressCopyToValue =
              (100 / this.selectedCopyTo.length) * this.progressCopyToSuccess
          } catch (error) {
            if (error.response && error.response.status === 403) {
              this.dialogForbidden = true
              return
            }

            const snackbar = {
              show: true,
              color: 'error',
              timeout: -1,
              message:
                error?.response?.data?.message || 'Something went wrong!',
            }
            this.$store.commit('SET_SNACKBAR', snackbar)
          }
        }
      }

      this.timeout = setTimeout(() => {
        this.dialogProgressCopyTo = false
        this.dialogCopyTo = false
        this.selectedCopyTo = []

        this.$emit('onCopyToSuccess')
      }, 500)
    },
    handleCancelCopyFrom() {
      this.dialogCopyFrom = false
      this.selectedCopyFrom = []
      this.searchTableCopyFrom = ''
      this.filterHardwareModelCopyFrom = ''
    },
    handleCancelCopyTo() {
      this.dialogCopyTo = false
      this.selectedCopyTo = []
      this.searchTableCopyTo = ''
      this.filterHardwareModelCopyTo = ''
      this.filterHardwareGroups = []
    },
    handleClickView(lockUnlockSelected) {
      this.dialogView = true
      if (this.tabLockUnlock === 0) {
        this.hardwareLockUnlockTableView = {
          hardware_code: lockUnlockSelected.hardware?.hardware_code,
          title_th: lockUnlockSelected.hardware?.title_th,
          time_detail: lockUnlockSelected.lock_detail.map((lock) => {
            return {
              time_period: lock.lock_time_period.map((item) => {
                if (item.time_period_start && item.time_period_end) {
                  return {
                    time_period_start: item.time_period_start,
                    time_period_end: item.time_period_end,
                    start:
                      Number(item.time_period_start.split(':')[0]) * 44 +
                      (Number(item.time_period_start.split(':')[1]) / 60) * 44,
                    end:
                      (Number(item.time_period_end.split(':')[0]) -
                        Number(item.time_period_start.split(':')[0])) *
                        44 +
                      Number(item.time_period_end.split(':')[1] / 60) * 44 -
                      Number(item.time_period_start.split(':')[1] / 60) * 44,
                  }
                }
              }),
            }
          }),
        }
      }
      if (this.tabLockUnlock === 1) {
        this.hardwareLockUnlockTableView = {
          hardware_code: lockUnlockSelected.hardware?.hardware_code,
          title_th: lockUnlockSelected.hardware?.title_th,
          time_detail: lockUnlockSelected.unlock_detail.map((unlock) => {
            return {
              time_period: unlock.unlock_time_period.map((item) => {
                if (item.time_period_start && item.time_period_end) {
                  return {
                    time_period_start: item.time_period_start,
                    time_period_end: item.time_period_end,
                    start:
                      Number(item.time_period_start.split(':')[0]) * 44 +
                      (Number(item.time_period_start.split(':')[1]) / 60) * 44,
                    end:
                      (Number(item.time_period_end.split(':')[0]) -
                        Number(item.time_period_start.split(':')[0])) *
                        44 +
                      Number(item.time_period_end.split(':')[1] / 60) * 44 -
                      Number(item.time_period_start.split(':')[1] / 60) * 44,
                  }
                }
              }),
            }
          }),
        }
      }
    },
    filterTableCopyFrom(value, search, item) {
      return (
        item.hardware?.hardware_code
          .toLowerCase()
          .includes(search.toLowerCase()) ||
        item.hardware?.title_th.toLowerCase().includes(search.toLowerCase()) ||
        item.hardware?.hardware_model_code
          .toLowerCase()
          .includes(search.toLowerCase())
      )
    },
    filterTableCopyTo(value, search, item) {
      return (
        item.hardware?.hardware_code
          .toLowerCase()
          .includes(search.toLowerCase()) ||
        item.hardware?.title_th.toLowerCase().includes(search.toLowerCase()) ||
        item.hardware?.hardware_model_code
          .toLowerCase()
          .includes(search.toLowerCase())
      )
    },
    handleCopyFrom() {
      this.dialogCopyFrom = true

      this.$store.state.loading = true

      const { company_uuid } = this.$store.state.authentication.company

      this.loadingHardwareModels = true
      this.fetchHardwareModels({ params: { company_uuid } })
        .catch((error) => {
          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        })
        .finally(() => (this.loadingHardwareModels = false))

      if (this.tabLockUnlock === 0) {
        this.fetchLocks({
          company_uuid,
          params: { dpc: 'lock-unlock-to-list-lock' },
        })
          .then(() => {
            this.$store.state.loading = false
            const locks = this.$store.state.lockUnlock.locks
            this.locks = [...locks]
          })
          .catch((error) => {
            this.$store.state.loading = false

            const snackbar = {
              show: true,
              color: 'error',
              timeout: -1,
              message:
                error?.response?.data?.message || 'Something went wrong!',
            }
            this.$store.commit('SET_SNACKBAR', snackbar)
          })
      }
      if (this.tabLockUnlock === 1) {
        this.fetchUnlocks({
          company_uuid,
          params: { dpc: 'lock-unlock-to-list-unlock' },
        })
          .then(() => {
            this.$store.state.loading = false
            const unlocks = this.$store.state.lockUnlock.unlocks
            this.unlocks = [...unlocks]
          })
          .catch((error) => {
            this.$store.state.loading = false

            const snackbar = {
              show: true,
              color: 'error',
              timeout: -1,
              message:
                error?.response?.data?.message || 'Something went wrong!',
            }
            this.$store.commit('SET_SNACKBAR', snackbar)
          })
      }
    },
    handleCopyTo() {
      this.dialogCopyTo = true

      this.$store.state.loading = true

      const { company_uuid } = this.$store.state.authentication.company

      this.loadingHardwareGroups = false
      this.fetchHardwaresGroup({ company_uuid })
        .catch((error) => {
          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        })
        .finally(() => (this.loadingHardwareGroups = false))

      this.loadingHardwareModels = true
      this.fetchHardwareModels({ params: { company_uuid } })
        .catch((error) => {
          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        })
        .finally(() => (this.loadingHardwareModels = false))

      if (this.tabLockUnlock === 0) {
        this.fetchLocks({
          company_uuid,
          params: { dpc: 'lock-unlock-to-list-lock' },
        })
          .then(() => {
            this.$store.state.loading = false
            const locks = this.$store.state.lockUnlock.locks
            this.locks = [...locks]
          })
          .catch((error) => {
            this.$store.state.loading = false

            const snackbar = {
              show: true,
              color: 'error',
              timeout: -1,
              message:
                error?.response?.data?.message || 'Something went wrong!',
            }
            this.$store.commit('SET_SNACKBAR', snackbar)
          })
      }
      if (this.tabLockUnlock === 1) {
        this.fetchUnlocks({
          company_uuid,
          params: { dpc: 'lock-unlock-to-list-unlock' },
        })
          .then(() => {
            this.$store.state.loading = false
            const unlocks = this.$store.state.lockUnlock.unlocks
            this.unlocks = [...unlocks]
          })
          .catch((error) => {
            this.$store.state.loading = false

            const snackbar = {
              show: true,
              color: 'error',
              timeout: -1,
              message:
                error?.response?.data?.message || 'Something went wrong!',
            }
            this.$store.commit('SET_SNACKBAR', snackbar)
          })
      }
    },
    handleSelectedTab() {
      if (this.lockUnlockCurrent) {
        this.$emit('onDayCopyCancel', this.lockUnlockCurrent)
        this.selectDayCopy = 0
        this.lockUnlockCurrent = null
      }
    },
    handleChangeDayCopy(dayTypeId) {
      this.lockUnlockCurrent = JSON.parse(JSON.stringify(this.lockUnlock))

      if (this.tabLockUnlock === 0) {
        const { lock_time_period } = this.lockUnlock.lock_detail.find(
          (item) => item.day_type.day_type_id === this.selectDayCopy
        )
        this.lockUnlock.lock_detail[dayTypeId - 1].lock_time_period = [
          ...lock_time_period,
        ]
      }

      if (this.tabLockUnlock === 1) {
        const { unlock_time_period } = this.lockUnlock.unlock_detail.find(
          (item) => item.day_type.day_type_id === this.selectDayCopy
        )
        this.lockUnlock.unlock_detail[dayTypeId - 1].unlock_time_period = [
          ...unlock_time_period,
        ]
      }

      this.$emit('onChangeDayCopy', this.lockUnlock)
    },
    handleCopyDayCancel() {
      this.$emit('onDayCopyCancel', this.lockUnlockCurrent)
      this.selectDayCopy = 0
      this.lockUnlockCurrent = null
    },
    handleCopyDay() {
      this.$emit('onDayCopy', this.lockUnlock)
      this.selectDayCopy = 0
      this.lockUnlockCurrent = null
    },
    onSave() {
      if (this.$refs.form.validate()) {
        if (this.selectDayCopy !== 0) {
          this.dialogAlertSelectDayCopy = true
          return
        }

        this.$store.state.loading = true

        const { company_uuid } = this.$store.state.authentication.company

        const payloadLock = {
          company_uuid,
          hardware_uuid: this.lockUnlock.hardware?.hardware_uuid,
          body: {
            title_th: 'title_th',
            title_en: 'title_en',
            lock_detail: this.lockUnlock.lock_detail.map((item) => ({
              day_type_id: item.day_type.day_type_id,
              lock_time_period: item.lock_time_period,
            })),
          },
          params: {
            dpc: 'lock-unlock-to-update-lock',
          },
        }
        const payloadUnlock = {
          company_uuid,
          hardware_uuid: this.lockUnlock.hardware?.hardware_uuid,
          body: {
            title_th: 'title_th',
            title_en: 'title_en',
            unlock_detail: this.lockUnlock.unlock_detail.map((item) => ({
              day_type_id: item.day_type.day_type_id,
              unlock_time_period: item.unlock_time_period,
            })),
          },
          params: {
            dpc: 'lock-unlock-to-update-unlock',
          },
        }
        Promise.all([
          this.editLock(payloadLock),
          this.editUnlock(payloadUnlock),
        ])
          .then(([lock, unlock]) => {
            this.$emit('onSaveLockUnlock', {
              hardware_uuid: this.lockUnlock.hardware?.hardware_uuid,
              lock_detail: lock.lock_detail,
              unlock_detail: unlock.unlock_detail,
            })

            this.$store.state.loading = false

            const snackbar = {
              show: true,
              color: 'success',
              timeout: 2000,
              message: 'แก้ไขข้อมูลสำเร็จ',
            }

            this.$store.commit('SET_SNACKBAR', snackbar)

            this.$refs.form.resetValidation()
            if (this.lockUnlockCurrent) {
              this.handleSelectedTab()
            } else {
              this.selectDayCopy = 0
            }
            this.$emit('formActionCompleted')
          })
          .catch((error) => {
            this.$store.state.loading = false

            if (error.response && error.response.status === 403) {
              this.dialogForbidden = true
              return
            }

            if (error.response && error.response.data) {
              const snackbar = {
                show: true,
                color: 'error',
                timeout: 4000,
                message: error.response.data.message || 'Something went wrong!',
              }

              this.$store.commit('SET_SNACKBAR', snackbar)

              this.$refs.form.resetValidation()
              if (this.lockUnlockCurrent) {
                this.handleSelectedTab()
              } else {
                this.selectDayCopy = 0
              }
              this.$emit('formActionCompleted')
            } else {
              const snackbar = {
                show: true,
                color: 'error',
                timeout: 4000,
                message: 'Something went wrong!',
              }
              this.$store.commit('SET_SNACKBAR', snackbar)
            }
          })
      }
    },
    onClose() {
      if (this.isLockUnlockDataChange) {
        this.confirmDialogDataChangeData = {
          title: 'ต้องการปิดใช่ไหม',
          text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการปิดโดยที่ยังไม่บันทึกข้อมูล',
          value: '',
        }
        this.confirmDialogDataChange = true
      } else {
        this.$refs.form.resetValidation()
        if (this.lockUnlockCurrent) {
          this.handleSelectedTab()
        } else {
          this.selectDayCopy = 0
        }
        this.$emit('formActionCompleted')
      }
    },
    cancelConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
    },
    submitConfirmDialogDataChange() {
      this.confirmDialogDataChange = false

      this.$refs.form.resetValidation()
      if (this.lockUnlockCurrent) {
        this.handleSelectedTab()
      } else {
        this.selectDayCopy = 0
      }
      this.$emit('formActionCompleted')
    },
    onReset() {
      this.$refs.form.resetValidation()
      if (this.lockUnlockCurrent) {
        this.handleSelectedTab()
      } else {
        this.selectDayCopy = 0
      }
      this.$emit('formActionCompleted')
    },
  },
  beforeDestroy() {
    clearTimeout(this.timeout)
  },
}
</script>

<style scoped>
.centered-input >>> input {
  text-align: center;
}

.red-text-input >>> input {
  color: red;
}
</style>
